<template>
    <div v-if="!historyMode" @click="statuses = !statuses" class="badge badge--header" :class="{
        'badge-red' : statusCode() == 'mm_build' || statusCode() == 'first_correct_mm' || statusCode() == 'second_correct_mm' || statusCode() == 'additional_correct_mm',
        'badge-yellow' : statusCode() == 'to_accept',
        'badge-navy' : statusCode() == 'first_gun_build' || statusCode() == 'second_gun_build' || statusCode() == 'first_correct_gun' || statusCode() == 'additional_correct_gun',
        'badge-green' : statusCode() == 'accept',
        'badge-light-grey' : statusCode() == 'archived',
        'badge-dark-grey' : statusCode() == 'cancelled',
        }">{{statusCode('name')}}
        <div class="statuses" :class="{'show' : statuses}">
        <ul>
            <li v-for="status in statusList" :class="{'disabled-status' : checkStatus(status ? status.code : '')}" :key="status.id" @click="updateStatus(status.id, status); statuses = false">
                {{status.name}}
            </li>
        </ul>
        </div>
        <div class="order-tooltip">
        zmień status
        </div>
    </div>  
</template>

<script>
export default {
    
    name: 'pageStatus',
    props:{

        page:{
            type: Object,
            default: () => {}
        },

        order:{
            default: () => {}
        },

        historyMode:{
            type: Boolean,
            default: false,
        },

        blocked:{
            type: Boolean,
            default: false,
        },

    },
    data(){

        return{

            statuses: false,
            statusList: [],

        }

    },
    methods:{

        statusCode(type){

            if(!this.order && !this.order.oldestPageStatus){
                return;
            }

            if(this.order){

                if(!this.page.status || this.page.status == 'null'){

                    return type != 'name' ? this.order.oldestPageStatus.code : this.order.oldestPageStatus.name;

                }else{

                    return type != 'name' ? this.page.status.code : this.page.status.name;

                }

            }
    
        },

        checkStatus(status){

            if(!this.historyMode && this.page && this.page.status.code){
            
                const user = this.$parent.$parent.$parent.$refs.head.user.roles[0];
                const currentStatus = this.page.status.code;

                if(status == 'waiting'){
                return true;
                }
                
                if(user == 'ROLE_ADMIN' || user == 'ROLE_SUPER_ADMIN'){
                return false;
                }

                if(user == 'ROLE_EDITOR'){
                return true;
                }

                if(user == 'ROLE_LOCAL' || user == 'ROLE_CENTRAL'){

                switch(status){

                    case 'first_gun_build' :

                    if(currentStatus == 'mm_build'){
                        return false;
                    }

                    return true;

                    break;

                    case 'first_correct_gun' :

                    if(currentStatus == 'first_correct_mm'){
                        return false;
                    }

                    return true;
                    
                    break;

                    case 'additional_correct_gun' :

                    if(currentStatus == 'additional_correct_mm'){
                        return false;
                    }

                    return true;
                    
                    break;

                    case 'accept' :

                    if(currentStatus == 'first_correct_mm' || currentStatus == 'second_correct_mm' || currentStatus == 'additional_correct_mm' || currentStatus == 'to_accept'){
                        return false;
                    }

                    return true;
                    
                    break;

                    case 'second_gun_build' :

                    if(currentStatus == 'second_correct_mm'){
                        return false;
                    }

                    return true;
                    
                    break;

                    default :

                    return true;

                }
                
                }

                if(user == 'ROLE_COORDINATOR'){

                switch(status){

                    case 'first_correct_mm' :

                    if(currentStatus == 'first_gun_build'){
                        return false;
                    }

                    return true;

                    break;

                    case 'second_correct_mm' :

                    if(currentStatus == 'first_correct_gun'){
                        return false;
                    }

                    return true;
                    
                    break;

                    case 'to_accept' :

                    if(currentStatus == 'first_gun_build' || currentStatus == 'first_correct_gun' || currentStatus == 'second_gun_build' || currentStatus == 'additional_correct_gun'){
                        return false;
                    }

                    return true;
                    
                    break;

                    case 'additional_correct_mm' :

                    if(currentStatus == 'to_accept'){
                        return false;
                    }

                    return true;
                    
                    break;

                    case 'archived' :

                    if(currentStatus == 'accept' || currentStatus == 'cancelled'){
                        return false;
                    }

                    return true;
                    
                    break;

                    case 'cancelled' :

                    return false;
                    
                    break;

                    default :

                    return true;

                }
                
                }

            }

            return true;

        },

        updateStatus(id, status){

            const token = localStorage.getItem('auth_token');

            this.$http.put(`order-pages/${this.page.id}/changes/${id}/status`, {}, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {
                console.log(response)

                this.$parent.$parent.getOrder();

            })
            .catch(error =>{
            
            console.error(error)

            })

        },

        getFormData(){

            const token = localStorage.getItem('auth_token');

            this.$http.get('order/form/data', {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

            this.statusList = response.data.status;

            })
            .catch(error =>{

                console.error(error.response);

            })

        },

        close(e){

            if(!e.target.classList.contains('badge')){

                this.statuses = false

            }

        },

    },
    mounted(){

        this.getFormData();
        document.addEventListener('click', this.close)

    }

}
</script>

<style lang="scss" scoped>

.badge--header{
  width:auto;
  padding: 10px;
  margin-left: 1%;
  margin-bottom: 5px;
  position: relative;
  cursor:pointer;

  &:hover .order-tooltip{
    visibility: visible;
  }
}

.statuses{
  position:absolute;
  margin-top:20px;
  width:auto;
  background:#fff;
  z-index: 100;
  left:0;
  visibility: hidden;

  & ul{
    margin:0;
    padding: 0;
    list-style: none;
    text-align: left;

    & li{
      padding:10px 5px;

      &:nth-child(odd){
        background:#edf7ff
      }
    }
  }

  &.show{
    visibility: visible;
  }
}

.disabled-status{
  cursor:default;
  opacity: 0.5;
}

</style>